import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  Ch_signAttestationGuardianDocumentInput,
  useChSignLegalGuardianMutation as useChSignLegalGuardianMutationType,
} from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChSignLegalGuardianMutation.graphql"

const mutation = graphql`
  mutation useChSignLegalGuardianMutation($input: Ch_signAttestationGuardianDocumentInput!) {
    ch_signAttestationGuardianDocument(input: $input) {
      ch_AttestationGuardian {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignLegalGuardianMutationType>, "variables"> & {
  id: Ch_signAttestationGuardianDocumentInput["id"]
}

const useChSignLegalGuardianMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChSignLegalGuardianMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignLegalGuardianMutation }
